import { Divider } from '@mui/material'

export const TitleButtonDivider = () => {
  return <Divider orientation="vertical" variant="middle" flexItem />
}